// Google vuelve a la raíz: recordar solo la pantalla y producto del correo,
// en esta pestaña y por 30 minutos. Nunca guarda una URL externa ni permisos.
export const CLAVE_RETORNO_PLANES = 'mipae:retorno:planes';
const VIGENCIA_MS = 30 * 60 * 1000;
const PRODUCTOS = new Set(['plus_estudiante', 'plus_enfermero', 'full']);

export function prepararRetornoPlanes(ventana = typeof window === 'undefined' ? null : window, ahora = Date.now()) {
  const params = new URLSearchParams(ventana?.location?.search || '');
  if (!ventana) return params;
  try {
    if (params.get('planes') === '1') {
      const producto = params.get('producto');
      ventana.sessionStorage.setItem(CLAVE_RETORNO_PLANES, JSON.stringify({ producto: PRODUCTOS.has(producto) ? producto : null, creado: ahora }));
      return params;
    }
    const raw = ventana.sessionStorage.getItem(CLAVE_RETORNO_PLANES);
    if (!raw) return params;
    const pendiente = JSON.parse(raw);
    if (!Number.isFinite(pendiente?.creado) || ahora < pendiente.creado || ahora - pendiente.creado >= VIGENCIA_MS
      || (pendiente.producto !== null && !PRODUCTOS.has(pendiente.producto))) {
      ventana.sessionStorage.removeItem(CLAVE_RETORNO_PLANES); return params;
    }
    // Un enlace explícito a otra pantalla tiene prioridad sobre el correo viejo.
    if (ventana.location.pathname !== '/' || params.has('lo_nuevo') || params.has('inicio') || params.has('legal') || ventana.location.hash === '#lab') return params;
    params.set('planes', '1');
    if (pendiente.producto) params.set('producto', pendiente.producto);
    ventana.history.replaceState(ventana.history.state, '', `/?${params.toString()}${ventana.location.hash || ''}`);
  } catch { /* Sin almacenamiento, conservar el enlace original y el acceso. */ }
  return params;
}

export function consumirRetornoPlanes(ventana = typeof window === 'undefined' ? null : window) {
  try { ventana?.sessionStorage?.removeItem(CLAVE_RETORNO_PLANES); } catch { /* Acceso sigue disponible. */ }
}
